module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sink"
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang "
  }, [_vm._v("Truth becomes fiction when the fiction’s true;")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang "
  }, [_vm._v("Real becomes not-real where the unreal’s real.")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "indent2"
  }, [_c('p', {
    staticClass: "hang "
  }, [_c('em', [_vm._v("—Cao Xueqin")]), _vm._v(", The Story of the Stone")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_vm._v("Tell all the truth but tell it slant.")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "indent2"
  }, [_c('p', {
    staticClass: "hang "
  }, [_c('em', [_vm._v("—Emily Dickinson")])])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "px3"
    }
  }), _vm._v(" "), _c('figure', {
    staticClass: "full "
  }, [_c('img', {
    attrs: {
      "alt": " ",
      "id": "fig_Fortunes_009_1",
      "src": "images/Fortunes_009_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "indent2"
  }, [_c('p', {
    staticClass: "hang "
  }, [_c('em', [_vm._v("—Anon.")]), _vm._v(", Oriental riff")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024016e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 69
// module chunks = 0